import styled from 'styled-components';

export const Button = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;

    svg {
        color: ${(props) => props.theme.palette.textLight};
    }
    &:hover {
        svg {
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }
`;
